import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../../../config";
import "./EstimateReady.css";

// "Estimate Ready" widget — a circular button that lights hot pink when Estimating
// has floorplans ready (Notify Complete) that Sales hasn't started an order for.
// Clicking opens the drill-down list. dataScope === "self" scopes to the logged-in
// salesperson's floorplans.
const EstimateReady = ({ auth: { auth }, dataScope = "all", userId }) => {
  const [count, setCount] = useState(0);
  const navigate = useNavigate();

  const token = auth && auth[0] ? auth[0].token : null;
  let tmpUserId = userId;
  if(auth && (auth[0]?.roleName ==='Sales' && auth[0]?.salesPersonId !=='')){
    tmpUserId = auth[0]?.salesPersonId
  }
  const scopedSalesPersonId = dataScope === "self" ? tmpUserId : null;
  useEffect(() => {
    if (!token) return;
    // Guard against setting state after the widget unmounts (the dashboard can
    // re-render/unmount widgets while this request is still in flight).
    let active = true;
    const params = {};
    if (scopedSalesPersonId) params.salesPersonId = scopedSalesPersonId;
    axios
      .get(`${API_URL}/Dashboard/api/Dashboard/EstimateReady`, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      })
      .then((res) => {
        if (!active) return;
        const rows = Array.isArray(res.data)
          ? res.data
          : (res.data && res.data.result) || [];
        setCount(rows.length);
      })
      .catch((err) => {
        if (!active) return;
        console.warn("Could not load Estimate Ready:", err.message);
      });
    return () => {
      active = false;
    };
  }, [token, scopedSalesPersonId]);

  const ready = count > 0;

  return (
    <div className="er-widget">
      <button
        type="button"
        className={`er-button ${ready ? "er-ready" : "er-calm"}`}
        onClick={() => navigate("/estimate-ready")}
        title="View floorplans ready for product selection"
      >
        <span className="er-label">Estimate Ready</span>
        {ready && <span className="er-count">{count}</span>}
      </button>
    </div>
  );
};

const mapStateToProps = ({ auth }) => ({ auth });

export default connect(mapStateToProps)(EstimateReady);
